"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HistoryDrawList = void 0;
const moment_timezone_1 = __importDefault(require("moment-timezone"));
class HistoryDrawList extends Array {
    constructor() {
        super(...arguments);
        this.getDrawDateConverted = () => {
            const drawHistoryList = new HistoryDrawList();
            if (this.length > 0) {
                this.forEach(x => {
                    x.drawDateConverted = (0, moment_timezone_1.default)(x.draw).format('MMM Do, YYYY');
                    x.startDateConverted = (0, moment_timezone_1.default)(x.start).format('MMM Do, YYYY');
                    x.endDateConverted = (0, moment_timezone_1.default)(x.end).format('MMM Do, YYYY');
                    drawHistoryList.push(x);
                });
            }
            return drawHistoryList;
        };
    }
}
exports.HistoryDrawList = HistoryDrawList;
//# sourceMappingURL=HistoryDrawList.js.map